import { featuredJobs } from "@/mocks/jobs";

const extraJobs = [
  { id: 7, title: "Product Manager", company: "InnovateCo", location: "Seattle, WA", salary: "$115,000 - $145,000", type: "Full-time", industry: "Technology", posted: "1 day ago", urgent: false, logo: "https://public.readdy.ai/ai/img_res/9adf7ae296c4f1f66c54595b2fb19989.jpg" },
  { id: 8, title: "Sales Director", company: "GrowthForce", location: "Boston, MA", salary: "$100,000 + Commission", type: "Full-time", industry: "Sales", posted: "2 days ago", urgent: true, logo: "https://readdy.ai/api/search-image?query=sales%20company%20logo%20red%20arrow%20minimalist%20professional&width=80&height=80&seq=wj2&orientation=squarish" },
  { id: 9, title: "Registered Nurse (ICU)", company: "Metro Health System", location: "Phoenix, AZ", salary: "$72,000 - $88,000", type: "Full-time", industry: "Healthcare", posted: "3 hours ago", urgent: true, logo: "https://readdy.ai/api/search-image?query=healthcare%20hospital%20company%20logo%20green%20cross%20minimalist%20professional&width=80&height=80&seq=wj3&orientation=squarish" },
  { id: 10, title: "Supply Chain Manager", company: "GlobalTrade Inc", location: "Miami, FL", salary: "$95,000 - $120,000", type: "Full-time", industry: "Logistics", posted: "5 days ago", urgent: false, logo: "https://readdy.ai/api/search-image?query=supply%20chain%20logistics%20company%20logo%20blue%20ship%20minimalist%20professional&width=80&height=80&seq=wj4&orientation=squarish" },
  { id: 11, title: "Content Strategist", company: "MediaPulse", location: "Remote", salary: "$65,000 - $85,000", type: "Remote", industry: "Marketing", posted: "1 day ago", urgent: false, logo: "https://readdy.ai/api/search-image?query=media%20content%20company%20logo%20purple%20pen%20minimalist%20professional&width=80&height=80&seq=wj5&orientation=squarish" },
  { id: 12, title: "Civil Engineer", company: "BuildRight Corp", location: "Denver, CO", salary: "$85,000 - $110,000", type: "Full-time", industry: "Engineering", posted: "4 days ago", urgent: false, logo: "https://readdy.ai/api/search-image?query=engineering%20construction%20company%20logo%20orange%20bridge%20minimalist%20professional&width=80&height=80&seq=wj6&orientation=squarish" },
];

const allJobs = [...featuredJobs.slice(0, 3), ...extraJobs];

export default function WonderfulJobsSection() {
  return (
    <section id="wonderful-jobs" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-amber-500 text-sm font-semibold uppercase tracking-wider">Handpicked for You</span>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">Wonderful Job Opportunities</h2>
          <p className="text-gray-500 text-sm mt-2">Curated top-tier positions from the world&apos;s leading companies</p>
        </div>

        {/* Jobs Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {allJobs.map((job) => (
            <div
              key={job.id}
              className="bg-white border border-stone-100 rounded-xl p-5 hover:border-amber-200 hover:shadow-sm transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl overflow-hidden bg-stone-50 flex-shrink-0">
                  <img src={job.logo} alt={job.company} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 text-sm group-hover:text-amber-600 transition-colors truncate">{job.title}</h3>
                  <p className="text-stone-500 text-xs truncate">{job.company}</p>
                </div>
                {job.urgent && (
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium bg-red-50 text-red-600 flex-shrink-0">Urgent</span>
                )}
              </div>
              <div className="space-y-1.5 mb-4">
                <div className="flex items-center gap-2 text-xs text-stone-500">
                  <i className="ri-map-pin-line text-amber-400"></i>
                  <span>{job.location}</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-stone-500">
                  <i className="ri-money-dollar-circle-line text-amber-400"></i>
                  <span>{job.salary}</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                  job.type === "Remote" ? "bg-green-50 text-green-700" : "bg-amber-50 text-amber-700"
                }`}>
                  {job.type}
                </span>
                <button className="text-xs font-semibold px-4 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-white transition-colors cursor-pointer whitespace-nowrap">
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="inline-flex items-center gap-2 border border-amber-400 text-amber-600 hover:bg-amber-500 hover:text-white font-semibold px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm">
            <i className="ri-briefcase-line"></i>
            Browse All 48,200+ Jobs
          </button>
        </div>
      </div>
    </section>
  );
}
